module.exports = __webpack_public_path__ + "static/media/like-active.273f5806.svg";